import { connect } from 'react-redux';
import i18next from 'i18next';
import React, { useEffect, useState } from 'react';

// ACTIONS
import { loading, loadingSuccess } from '@actions/loading';
import { showErrorMessage, showSuccessMessage } from '@actions/messageconfirmation';

// COMMONS
import { isForbiddenAPIError } from '@commons/utils/errors';
import NavigationBar from '@commons/NavigationBar';

// SELECTORS
import { getClientInfo } from '@selectors/client';

// SERVICES
import storageAreaService from '@services/storageArea';

import { ContentContainer, PageContainer } from '../styledComponents';
import StorageAreaRecipeMappings from '../storageAreaMappings/recipeMappings';

const StorageAreaRecipes = (props) => {
  const {
    history,
    match: { path, params },
    pageLoaded,
    pageLoading,
    showErrorMessage,
  } = props;

  const storageAreaId = params.id;

  const [isLoading, setIsLoading] = useState(true);
  const [storageArea, setStorageArea] = useState({});

  useEffect(() => {
    if (!params.id) {
      return;
    }

    pageLoading();

    (async () => {
      try {
        const fetchedStorageArea = await storageAreaService.getStorageAreaById(params.id);

        setStorageArea(fetchedStorageArea);
      } catch (error) {
        showErrorMessage(i18next.t('ADMIN.STORAGE_AREAS.STORAGE_AREA_DETAIL_FETCHING_ERROR'));

        /**
         * This condition is kept to make sure to never forget user consultation perimeter restrictions
         * if we come to update default history back behaviour
         */
        if (isForbiddenAPIError(error)) {
          history.goBack();
        }

        history.goBack();
      } finally {
        setIsLoading(false);
        pageLoaded();
      }
    })();
  }, []);

  return (
    <>
      <NavigationBar
        path={path}
        storageArea={{
          id: storageAreaId,
          name: storageArea.name || '',
        }}
        bigTopBar
        enableActionBottomOrder
      />
      <PageContainer>
        <ContentContainer>
          <StorageAreaRecipeMappings
            existingStorageArea={storageArea || null}
            isLoading={isLoading}
            storeIds={storageArea.storeId ? [storageArea.storeId] : []}
          />
        </ContentContainer>
      </PageContainer>
    </>
  );
};

const mapStateToProps = (state) => ({
  client: getClientInfo(state.baseReducer.user),
});

const mapDispatchToProps = (dispatch) => ({
  showSuccessMessage: (message) => {
    dispatch(showSuccessMessage(message));
  },
  showErrorMessage: (message) => {
    dispatch(showErrorMessage(message));
  },
  pageLoading: () => {
    dispatch(loading());
  },
  pageLoaded: () => {
    dispatch(loadingSuccess());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(StorageAreaRecipes);
